import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';

import * as SupplierSpecialOffersDetailOverviewActions from '../overview/store/supplier-special-offers-detail-overview-actions';
import { Api } from '../../../../../api';
import { AppState } from '../../../../../store/models/app-state';
import { ReduxDispatch } from '../../../../../store/use-thunk-dispatch';
import { SaveResult } from '../../../../../common/models/save-result';
import { supplierSpecialOffersDetailIsValidSelector } from './supplier-special-offers-detail-selectors';

export const SUPPLIER_SPECIAL_OFFERS_DETAIL_RESET = 'SUPPLIER_SPECIAL_OFFERS_DETAIL_RESET';
export const SUPPLIER_SPECIAL_OFFERS_DETAIL_SAVE = 'SUPPLIER_SPECIAL_OFFERS_DETAIL_SAVE';
export const SUPPLIER_SPECIAL_OFFERS_DETAIL_DELETE = 'SUPPLIER_SPECIAL_OFFERS_DETAIL_DELETE';

export const resetSupplierSpecialOffersDetail = () => {
    return {
        type: SUPPLIER_SPECIAL_OFFERS_DETAIL_RESET,
    };
};

export const deleteSupplierSpecialOffer =
    () =>
    async (dispatch: ReduxDispatch, getState: () => AppState, { api }: { api: Api }) => {
        const id = getState().contentManagement.supplierSpecialOffers.detail.overview.supplierSpecialOffer?.id;
        if (!id) {
            return;
        }
        dispatch({ type: SUPPLIER_SPECIAL_OFFERS_DETAIL_DELETE, payload: { id } });

        const response = await api.contentManagement.SupplierSpecialOffers.Detail.deleteSupplierSpecialOffer(id);

        if (!response.success) {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };

export const saveSupplierSpecialOffer = () => {
    return async (dispatch: ReduxDispatch, getState: () => AppState) => {
        dispatch({ type: SUPPLIER_SPECIAL_OFFERS_DETAIL_SAVE });

        const state = getState();
        const isAllValid = supplierSpecialOffersDetailIsValidSelector(state);
        const overviewState = state.contentManagement.supplierSpecialOffers.detail.overview;

        if (!isAllValid) {
            if (overviewState.supplierSpecialOffer?.id) {
                dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.formErrors')));
            }
            return;
        }

        const promises: Promise<SaveResult>[] = [];

        if (overviewState.isDirty) {
            promises.push(dispatch(SupplierSpecialOffersDetailOverviewActions.saveSupplierSpecialOffersDetail()));
        }
        // dispatch other save actions here

        const results = await Promise.all(promises);
        if (results.every(result => result === SaveResult.Success)) {
            dispatch(Snackbar.enqueue(PoolNotification.success('app.snackbar.supplierSpecialOfferSaved')));
        } else if (results.some(result => result === SaveResult.FormErrors)) {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.formErrors')));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};
